import { colors } from "@minuthq/meatball-ui-react"

import { HardwareType, TMountStatus } from "src/data/devices/types/deviceTypes"
import { ITranslateFunction } from "src/i18n/i18nTypes"
import { langKeys } from "src/i18n/langKeys"
import { useTranslate } from "src/i18n/useTranslate"
import P2SensorMounted from "src/ui/icons/p2-mounted.svg"
import P2SensorUnknown from "src/ui/icons/p2-unknown-mount-state.svg"
import P2SensorUnmounted from "src/ui/icons/p2-unmounted.svg"
import P3SensorMounted from "src/ui/icons/p3-mounted.svg"
import P3SensorUnknown from "src/ui/icons/p3-unknown-mount-state.svg"
import P3SensorUnmounted from "src/ui/icons/p3-unmounted.svg"
import { MTooltip } from "src/ui/MTooltip/MTooltip"
import { SVGProps } from "src/utils/tsUtil"

export function MountStatus({
  deviceType,
  offline,
  status,
  ...props
}: {
  deviceType: HardwareType
  offline: boolean
  status?: TMountStatus
} & SVGProps) {
  const { t } = useTranslate()
  const content = getMountStatusContent({ offline, t, deviceType, status })

  if (deviceType === HardwareType.L1) {
    return <span>-</span>
  }

  return (
    <MTooltip title={<span>{content.tooltip}</span>}>
      <div>
        <content.icon
          width={24}
          height={24}
          color={content.colorOverride}
          {...props}
        />
      </div>
    </MTooltip>
  )
}

function getMountStatusContent({
  offline,
  t,
  deviceType,
  status,
}: {
  offline: boolean
  t: ITranslateFunction
  deviceType: HardwareType
  status?: TMountStatus
}) {
  // A1 reuses P3 icons as they look similar from a side view
  const useP3Icons =
    deviceType === HardwareType.M3 || deviceType === HardwareType.A1
  const aggregatedStatus =
    status === "mounted" && offline ? "offline-mounted" : status

  switch (aggregatedStatus) {
    case "offline-mounted": {
      return {
        icon: useP3Icons ? P3SensorMounted : P2SensorMounted,
        tooltip: t(langKeys.tamper_unknown),
        colorOverride: colors.neutralDark2,
      }
    }

    case "mounted": {
      return {
        icon: useP3Icons ? P3SensorMounted : P2SensorMounted,
        tooltip: t(langKeys.tamper_attached),
        colorOverride: !offline ? colors.systemGood : undefined,
      }
    }

    case "unmounted": {
      return {
        icon: useP3Icons ? P3SensorUnmounted : P2SensorUnmounted,
        tooltip: t(langKeys.tamper_removed),
      }
    }

    case "unsupported": {
      return {
        icon: useP3Icons ? P3SensorUnknown : P2SensorUnknown,
        tooltip: t(langKeys.tamper_unsupported),
      }
    }

    default: {
      return {
        icon: useP3Icons ? P3SensorUnknown : P2SensorUnknown,
        tooltip: t(langKeys.tamper_unknown),
      }
    }
  }
}
